import { Modal } from "antd";
import { Dropdown, Space, Form } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
// import "./Style.css";
import { Input } from "antd";
import { Button } from "antd";
import { useState } from "react";
import TextArea from "antd/lib/input/TextArea";


const RemarksComponent  = (props) => {
    const form = Form.useForm();
    const {
        resData,
        remarks,
        setRemarks,
        isHistory,
        setIsHistory,
    } = props;
    const [addRemarks, setAddRemarks] = useState('');
    
    const handleModalCancel = () =>{
        setRemarks(false);
    }

    const handleSubmit = () => {
        
    }

    const handleChange = (event) =>{
        setAddRemarks(event.target.value);
    }

    return(
    <>
        
        <Modal className="remarksModal" open={remarks} width={350} style = {{  }} maskStyle={{ backgroundColor: 'rgba(0, 0, 0 , 0.1)' }} footer={[]}  onCancel={handleModalCancel}  > 
           <div style={{    width: "100%", maxHeight: "250px", overflowY: "auto", marginTop: "10px",}}>{resData}</div> 
          { isHistory == true ?  [] : <div className="inputContainer" style={{display:"flex", width:"100%"}} >
            <Form.Item style={{marginBottom:"0", width:"90%"}}>
                <TextArea
                    className="textArea-input"
                            style={{width:"100%", marginTop:10}}
                            placeholder="Enter Remarks"
                            onChange={handleChange}
                            autoSize={{ minRows: 3, maxRows: 5 }}

                          />
            </Form.Item>
            <Button className="btn-remark" style={{border:"none", width:"10%"}} onClick={handleSubmit}>
            <ArrowRightOutlined />
            </Button>
            </div>}
        </Modal> 
      
        
        

{/* <div className="remarksData-container">
        <Dropdown className='btn'
            overlay={
              <div style={{
                backgroundColor: "#fff",
                padding: "10px",
                boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                maxHeight: "200px",
                overflowY: "auto",
              }}>
                {resData}
              </div>}
            trigger={['click']}>
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                View
              </Space>
            </a>
          </Dropdown>
        </div> */}
        </>
    )

}


export default RemarksComponent;